//REGISTER
export const REGISTER = "/usersApi/api/auth/register";

//OTP
export const VERIFY_OTP = "/usersApi/api/auth/activate-account?token=";
export const VERIFY_EMAIL= "/usersApi/api/auth/reset-password";
export const CHANGE_PASSWORD_URL= "usersApi/api/users/change-password";
//LOGIN
export const LOGIN = "/usersApi/api/auth/authenticate";


export const FIND_ALL_GOALS="/usersApi/api/users/goals/findAllGoals";

// DIET
export const FIND_ALL_RECIPES="/usersApi/api/alimentary/recipes/findAllRecipes";
export const FIND_HEIGHT_USER="/usersApi/api/logs/log-Weight";
export const FIND_ALL_MEALPLANS="/usersApi/api/alimentary/mealPlan/getAllMealPlans";

export const ALL_PREFERENCES="/usersApi/api/users/preferences/getAllPreferences";
export const USER="/usersApi/api/users/findUser/";
export const USERUPDATE="/usersApi/api/users/update-user";
export const USERUPDATE1="/usersApi/api/users/update-standard";


export const POST_FAKE_JWT_LOGIN = "/post-jwt-login";
export const POST_FAKE_PASSWORD_FORGET = "/auth/forgot-password";
export const POST_FAKE_JWT_PASSWORD_FORGET = "/jwt-forget-pwd";
export const SOCIAL_LOGIN = "/social-login";

// sport
export const WORKOUTBYUSER="/usersApi/api/finallyWorkoutProgram/get-program-of-user/";
export const CATEGORY_SPORT="/usersApi/api/category/findAllCategories";


